export default __webpack_public_path__ + "static/landing-6717108547a82775884818852bf81416.png";